const cdn = 'cdn.tourist-online.de';
export default cdn;
